import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import "@/styles/globals.css";
import "@/styles/seo-content.css";
import Head from "next/head";
import { createContext, useState } from "react";
import { getDomainLanguage } from "@/hooks/getDomain";
import { seoLocales } from "@/hooks/seoLocales"; // already assumed

export const AppContext = createContext();

App.getInitialProps = async (appContext) => {
  const { Component, ctx } = appContext;
  let pageProps = {};

  if (Component.getInitialProps) {
    pageProps = await Component.getInitialProps(ctx);
  }

  // Always ensure domain and countryCode are set, even on pages without getServerSideProps
  if (!pageProps.domain && ctx.req) {
    const [domain, countryCode] = getDomainLanguage(ctx.req);
    pageProps.domain = pageProps.domain || domain;
    pageProps.countryCode = pageProps.countryCode || countryCode;
  }

  return { pageProps };
};

export default function App({ Component, pageProps }) {
  
  const { translation: initialTranslation, domain, countryCode } = pageProps;
  const [translation, setTranslation] = useState(initialTranslation);

  return (
    <AppContext.Provider
      value={{
        translation,
        setTranslation,
        countryCode,
      }}
    >
      <Head>
        {domain && (
          <link rel="icon" href={`https://www.${domain}/${countryCode ? `favicon-${countryCode}.png` : 'favicon.png'}`} type="image/png" />
        )}
        <meta name="language" content={seoLocales[domain]?.lang || "en"} />
        <meta httpEquiv="content-language" content={seoLocales[domain]?.lang || "en"} />
        {domain === "1001promocodes.com" && (
          <>
            <meta name="cc" content={countryCode || ""} />
            <meta name="dn" content={domain || ""} />
            <meta name="goid" content={pageProps.firstOfferId || 0} />
            <meta name="sid" content={pageProps.store?.id || 0} />
          </>
        )}
      </Head>
      <div className="flex flex-col min-h-screen justify-between">
        <div>
          <Navbar pageProps={pageProps} />
          <Component {...pageProps} />
        </div>
        <Footer pageProps={pageProps} />
      </div>
    </AppContext.Provider>
  );
}
